import { Button } from "~/design-system/components";

type UserButtonProps = {
  onClick: () => void;
  title: string;
  children: React.ReactNode;
};

export function HeaderButton({ children, onClick, title }: UserButtonProps) {
  return (
    <Button
      className="hover:bg-primary-light rounded-full border border-transparent p-0 hover:border-black lg:p-2"
      onClick={onClick}
      title={title}
      aria-label={title}
    >
      {children}
    </Button>
  );
}
